import React from "react";

interface SelectOption {
  label: string;
  value: string;
}

interface GenericSelectProps {
  label?: string;
  containerClassName?: string;
  labelClassName?: string;
  selectClassName?: string;
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  placeholder?: string;
  error?: string;
  disabled?:boolean
}

export const GenericSelectInput: React.FC<GenericSelectProps> = ({
  containerClassName = "mb-4",
  label = "Select Option",
  labelClassName = "block text-gray-700",
  selectClassName = "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
  options,
  value,
  onChange,
  required = false,
  placeholder = "Choose...",
  error,
  disabled = false
}) => {
  return (
    <div className={containerClassName}>
      <label className={labelClassName}>{label}</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={selectClassName}
        required={required}
        disabled={disabled}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((opt) => (
          <option key={`${opt.value}-${options.indexOf(opt)}`} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && <p className="text-sm text-red-600 mt-1">{error}</p>}
    </div>
  );
};
